import { render } from "./NotifBubble.vue?vue&type=template&id=75b8b2ac&scoped=true"
import script from "./NotifBubble.vue?vue&type=script&lang=js"
export * from "./NotifBubble.vue?vue&type=script&lang=js"

import "./NotifBubble.vue?vue&type=style&index=0&id=75b8b2ac&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-75b8b2ac"

export default script